import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { gql, useQuery } from '@apollo/client'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { findIndex, some } from 'lodash'
import BuildIcon from 'components/material-symbol/icons/Build'
import SelectionGroup from '../create-profile-form/selection-group'
import {
  SelectionCheckboxList,
  SelectionCheckboxOption,
} from '../create-profile-form/selection-checkbox-option'
import { useCreateProfileFieldStyles } from '../create-profile-form/field-styles'

const MAX_SKILLS = 8
const skillsMsg = `Select up to ${MAX_SKILLS} skills.`

const SkillsQuery = gql`
  query Skills {
    Skills {
      message
      success
      skills {
        skillId
        skillName
        description
      }
    }
  }
`

export const Skills = ({ skillTypes, hideHeader = false }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const { register, control } = useFormContext()
  const { append, remove, fields } = useFieldArray({
    name: 'skills',
    control,
  })

  const isChecked = (skillId, checkedSkills) => {
    return some(checkedSkills, { skillId })
  }

  const toggleSkillChecked = (skillId, checkedSkills) => {
    isChecked(skillId, checkedSkills)
      ? remove(findIndex(checkedSkills, { skillId }))
      : append({ skillId })
  }

  return (
    <Box className={fieldClasses.fieldSection}>
      {!hideHeader ? (
        <Typography variant="h4" gutterBottom>
          Skills *
        </Typography>
      ) : null}
      <Box className={fieldClasses.fieldStack}>
        <SelectionGroup
          title="Skills"
          description={skillsMsg}
          icon={BuildIcon}
          required
        >
          <SelectionCheckboxList>
            {skillTypes.map((skillType, i) => (
              <SelectionCheckboxOption
                key={skillType.skillId}
                checked={isChecked(skillType.skillId, fields)}
                label={skillType.skillName}
                name={`skills[${i}].skillId`}
                value={skillType.skillId}
                onChange={() => toggleSkillChecked(skillType.skillId, fields)}
              />
            ))}
          </SelectionCheckboxList>
        </SelectionGroup>
      </Box>
      <Box display="none" aria-hidden="true">
        {fields.map((item, index) => (
          <input
            key={item.id}
            type="hidden"
            ref={register()}
            name={`skills[${index}].skillId`}
            value={item.skillId}
          />
        ))}
      </Box>
    </Box>
  )
}

export default function Skill({ hideHeader = false }) {
  const { data, loading, error } = useQuery(SkillsQuery)
  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />
  return <Skills skillTypes={data?.Skills?.skills} hideHeader={hideHeader} />
}
